import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPlanDetails } from '../../store/reducers/priceReducer';
import Spinner from './../Spinner';
import { Link } from 'react-router-dom';

const PriceDetails = ({ code, id }) => {

    const dispatch = useDispatch();
    const priceListState = useSelector((state) => state.priceList || {}); // From Reducers
    const reducerData = useSelector(state => state.priceList.apiResponse || {});
    const { apiResponse, loading, apiErrorMsg } = priceListState;
  console.log("apiResponseapiResponse",apiResponse);
    const priceListData = apiResponse.data || {};

    useEffect(() => {

        if (id) {
          dispatch(fetchPlanDetails(id));
        }

      }, [dispatch, id]);

     if (loading) {
        return (
            <Spinner />
          );
     }
  
    return (
        
      <div className="plan-contianer">
        <div className="heading-plan">
          {/* <h4>{code} Wheeler Annual Plan</h4> */}
          <h4>{priceListData.plan_description}</h4>
        </div>
  
        <div className="price-card">
          <div className="tarif-details">
            <div className="plan-name">
              {/* <h4 className="plan-text">{code} Wheeler Annual Plan</h4> */}
              <span className="plan-text">{priceListData.plan_description}</span>
            </div>
            <div className="amount">
              <span>₹{priceListData.amount}</span>
            </div>
            <div className="year">
              <span>{priceListData.validity_in_months === 12 ? '1 Year' : priceListData.validity_in_months}</span>
            </div>
          </div>
          <div className="tax-details">
            <div className="breakup">
              {/* <p>What's included <img src="/assets/accordion.svg" alt="What included" /></p> */}
              <div className="view-all">
                <Link to="/membership-features" state={reducerData}>View All Membership Features</Link>
             </div>
            </div>
            {/* <div className="tax">
              <span>₹{(priceListData.amount*2)}</span>
            </div>
            <div className="off">
              <span>50% Off</span>
            </div> */}
          </div>
        </div>
        <div className='power-by'>
          <span>Powered by</span>
          <img src="/assets/footer_logo.png" alt="Powered By" />
        </div>
      </div>
    );
  }
export default PriceDetails;